import './ErrorBlock.scss';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import cx from 'classnames';

interface ErrorBlockProps {
  height?: number | string;
  width?: number | string;
  solid?: boolean;
  message?: string;
}

const ErrorBlock = ({ height, width, solid, message }: ErrorBlockProps) => {
  const { t } = useTranslation();
  return (
    <div
      style={{ height: height || '100%', width: width || '100%' }}
      className={cx('ErrorBlock', { 'ErrorBlock--solid': solid })}
    >
      {message || t('somethingWentWrong')}
    </div>
  );
};

export default memo(ErrorBlock);
